import type { SVGProps } from 'react';

const Svg22Mp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M3 3v18h18V3zm3.5 5h3V7h-3V5.5H11V9H8v1h3v1.5H6.5zm6 10.5H11V14h-1v3H8.5v-3h-1v4.5H6v-6h6.5zM13 8h3V7h-3V5.5h4.5V9h-3v1h3v1.5H13zm5 9h-3v1.5h-1.5v-6H18z" />
    <path d="M15 14h1.5v1.5H15z" />
  </svg>
);
export default Svg22Mp;
